// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"c88fce1a","678":"33eb4dd5","963":"94d27e1e"}[chunkId] + ".chunk.js";
};